import {Tag} from 'antd';
import * as React from 'react';
import {ProjectTemplateSummary} from '../../../../stores/templates-store';


interface ProjectTemplatesColumnProps {
    projectTemplates: ProjectTemplateSummary[],
}

class ProjectTemplatesColumn extends React.Component<ProjectTemplatesColumnProps> {

    public render() {
        return (
            <div style={{ display: 'flex', flexDirection: "row", flexWrap:"wrap" }}>
                {this.props.projectTemplates.map(projectTemplate => (
                    <div>
                        <Tag color='blue' >{projectTemplate?.title ?? projectTemplate}</Tag>
                    </div>
                ))}
            </div>
        );
    }
}

// Wire up the React component to the Redux store
export default ProjectTemplatesColumn;